















import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import FEButton from '@/components/ui/FEButton.ts.vue'
import FEIcon from '@/components/ui/FEIcon.ts.vue'


@Component({
  components: {
    FEButton,
    FEIcon,
  },
})
export default class FEButtonCreate extends Vue {
  @Prop(String)
  public label!: string;
}
